import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/components/layout/ThemeProvider';
import { initSentry } from '@/lib/sentry';
import { installPreloadErrorRecovery } from '@/lib/preload-recovery';
import { router } from '@/router';
import '@/lib/i18n';
import '@/styles/globals.css';

// Sentry runs before React mounts so any error in the initial render
// is captured. No-op until VITE_SENTRY_DSN is set (dev default).
initSentry();
// Recover from stale lazy-chunk imports after a deploy (reload once).
installPreloadErrorRecovery();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} context={{ queryClient }} />
        <Toaster richColors closeButton className="print:hidden" />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
